// extracted by mini-css-extract-plugin
module.exports = {"content":"_772e1b1e50--content--k07WI","icon-wrapper":"_772e1b1e50--icon-wrapper--zsmIz","heading":"_772e1b1e50--heading--F2H9Q","footer":"_772e1b1e50--footer--fizR5"};